<template>
    <div v-if="options.length">
        <p
            for="house-name-filter"
            class="text-xs sm:text-sm font-semibold text-brand-2-950 mb-2"
        >
            <span class="flex items-center justify-between gap-2">
                House

                <button
                    v-if="props.value"
                    class="text-brand-2-950/70 text-xsss hover:text-brand-2-950 lh-transition"
                    type="button"
                    @click="clear"
                >
                    Clear
                </button>
            </span>
        </p>

        <select
            id="house-name-filter"
            class="select"
            :disabled="props.loading"
            @change="change"
        >
            <option
                value=""
                :selected="!props.value"
            >
                Select...
            </option>
            <option
                v-for="option in options"
                :key="option.id"
                :value="option.slug"
                :selected="props.value === option.slug"
            >
                {{ option.name }}
            </option>
        </select>
    </div>
</template>

<script setup>
    import { ref } from 'vue';

    const emit = defineEmits(['value']);

    const props = defineProps([
        'loading',
        'type',
        'value',
    ]);

    const options = ref(Filters.houseNames);

    function change(event) {
        const value = event.target.value;

        emit('value', value);
    }

    function clear() {
        emit('value', '');
    }
</script>
